// extracted by mini-css-extract-plugin
export default {"tag":"g8pKmA"};